import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import moment from "moment";

const useStyles = makeStyles(theme => ({
  activityButton: {
    backgroundColor: "#E5F2FF",
    padding: "8px 35px",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#E5F2FF",
    },
  },
}));

//#region Helper Methds
const isTodayDate = checkDate =>
  new Date(checkDate).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0);

export const stringToColor = str => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 3) - hash);
  }
  const color = Math.abs(hash).toString(16).substring(0, 6);

  return "#" + "1BC5BD".substring(0, 6 - color.length) + color;
};
//#endregion

function CustomerActivity(props) {
  const { businessCompanyInfo } = useSelector(state => state.ContactsReducer);
  const classes = useStyles();
  return (
    <div>
      <div className='customerContactInner'>
        <div className='customerContactHeader'>
          Recent Activity{" "}
          <span>
            {/* <Button color='primary' className={classes.activityButton}>
              View All
            </Button> */}
          </span>
        </div>
        {businessCompanyInfo ? (
          businessCompanyInfo.customerActivities ? (
            businessCompanyInfo.customerActivities.map((x, index) => (
              <div key={index} className='activityBody'>
                <span className='activityDate'>
                  <span
                    className='circle'
                    style={{
                      border: `4px solid ${
                        !x.action
                          ? "#F64E60"
                          : stringToColor(
                              `${index}${moment(x.actionTime)
                                .format("HH:mm A")
                                .toString()}`
                            )
                      }`,
                    }}
                  />
                  {isTodayDate(x.actionTime)
                    ? moment(x.actionTime).format("hh:mm A")
                    : moment(x.actionTime).format("MMMM DD, YYYY")}
                </span>
                <span className='activityDesc'>{x.activity}</span>
              </div>
            ))
          ) : (
            <div></div>
          )
        ) : (
          <div></div>
        )}
        {businessCompanyInfo?.customerActivities?.length === 0 && (
          <span>No activity</span>
        )}
      </div>
    </div>
  );
}

export default CustomerActivity;
